/**
 * B2B Translations Barrel
 * =======================
 * Merges shared common translations with all B2B-specific translations.
 */

import { commonTranslations, mergeTranslations, Translations } from '../shared/i18n';
import { managementTranslations } from './management';
import { invoiceListTranslations } from './invoiceList';
import { invoiceDetailTranslations } from './invoiceDetail';
import { settingsTranslations } from './settings';

export const allTranslations: Translations = mergeTranslations(
    commonTranslations,
    managementTranslations,
    invoiceListTranslations,
    invoiceDetailTranslations,
    settingsTranslations,
);
